import { reducer, actions } from "@grandvisionhq/state";
import { loadReviewWrite, loadReviewSnippet, loadReviewDisplay, updateReviewDisplay } from "./actions.js";
const initialState = {
  reviewWrite: null,
  reviewSnippet: null,
  reviewDisplay: null
};
const reviewsReducer = reducer(
  initialState,
  /**
   * Load widgets
   */
  actions.on(loadReviewWrite, (state, action) => ({
    ...state,
    reviewWrite: action.payload
  })),
  actions.on(loadReviewSnippet, (state, action) => ({
    ...state,
    reviewSnippet: action.payload
  })),
  actions.on(loadReviewDisplay, (state, action) => ({
    ...state,
    reviewDisplay: action.payload
  })),
  /**
   * Update widgets
   */
  actions.on(updateReviewDisplay, (state, action) => {
    return state.reviewDisplay !== null ? {
      ...state,
      reviewDisplay: {
        ...state.reviewDisplay,
        variantId: action.payload.variantId
      }
    } : state;
  })
);
export {
  reviewsReducer as default,
  initialState,
  reviewsReducer
};
//# sourceMappingURL=reducer.js.map
